import { createContext } from "react";

export enum ConsentDialogState {
    None = 0,
    Refuse = 1,
    ResendPip = 2
}

interface IConsentDialogContext {
    dialogState: ConsentDialogState;
    setDialogState: (dialogState: ConsentDialogState) => void;
    patientStudyNumber: string | null;
    setPatientStudyNumber: (patientStudyNumber: string | null) => void;
    institutionCode: string | null | undefined;
}


const ConsentDialogContext = createContext<IConsentDialogContext>({
    dialogState: ConsentDialogState.None,
    setDialogState: () => undefined,
    patientStudyNumber: null,
    setPatientStudyNumber: () => undefined,
    institutionCode: null
});


export default ConsentDialogContext;
